module.exports = __webpack_public_path__ + "static/media/3.927f10bf.gif";